import Banner from "../../components/Banner";
import Cards from "../../components/Cards";
import Description from "../../components/Description";
import Download from "../../components/Download";
import ExclusiveFeatures from "../../components/ExclusiveFeatures";
import FaqSection from "../../components/FaqSection";

const Home = () => {
    return <>
      <Banner />
        <Description />
        <ExclusiveFeatures />
        <Cards />
        <Download />
        <FaqSection />
    </>
}
export default Home;